import { render } from "./RegisterOptionsView.vue?vue&type=template&id=223c5c66&scoped=true"
import script from "./RegisterOptionsView.vue?vue&type=script&lang=js"
export * from "./RegisterOptionsView.vue?vue&type=script&lang=js"

import "./RegisterOptionsView.vue?vue&type=style&index=0&id=223c5c66&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223c5c66"]])

export default __exports__